import React, {Component} from 'react';
import PropTypes from 'prop-types';
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
//import Countdown from './Countdown';
import Button from './Buttons';
import * as firebase from 'firebase';

/**
 * Receives paused, uid, and sessionid props from OrderbookContainer
 *
 * this component deals with submitting market orders as well as
 * rendering the start button(will need to change)
 */
class MarketOrders extends Component {
    constructor(props) {
        //console.log("MarketOrder constructor " + props);
        super(props);
        this.state = {
            paused: this.props.paused
        }
    }

    /**
     * checks if the market order was a Bid and sets that order to OrdersPending
     *
     *  if statements handle various checks (to validate input)
     * @param event
     */
    handleMarketKeyUp = (event) => {
        //console.log("MarketOrder handleMarketKeyUp ", event);
        let newOrderRef;
        let order;

        const ordersPendingRef = firebase.database().ref().child(this.props.institution).child("Sessions").child(this.props.sessionid).child("Users").child(this.props.uid).child("OrdersPending");

        if (event.key === 'Enter') {
            if (event.target.value != null && !isNaN(event.target.value) && event.target.value % 1 === 0) {
                let volumeInt = parseInt(event.target.value, 10);
                if (volumeInt > 0 && volumeInt <= 999) {
                    if (event.target.name === 'marketBid') {
                        order = {
                            Type: "Bid",
                            Volume: volumeInt,
                            UserId: this.props.uid,
                            AssetId: "INTC",
                            Strike: null,
                            Class: "Market"

                        };
                        //console.log(order);
                        newOrderRef = ordersPendingRef.push();
                        newOrderRef.set(order);
                        event.target.value = "";
                    } else {
                        //checks if the market order was a Ask and sets that order
                        //to OrdersPending
                        order = {
                            Type: "Ask",
                            Volume: volumeInt,
                            AssetId: "INTC",
                            UserId: this.props.uid,
                            Strike: null,
                            Class: "Market"
                        };
                        //console.log(order);
                        newOrderRef = ordersPendingRef.push();
                        newOrderRef.set(order);
                        event.target.value = "";
                    }
                } else {
                    alert("You must enter a number between 0 and 999");
                    event.target.value = "";
                }
            } else {
                alert("You must enter a valid whole number");
                event.target.value = "";
            }
        }
    };

    /**
     * checks to see if the game is paused and
     * sets paused state to true or false
     */
    componentWillReceiveProps(nextProps) {
        //console.log("MarketOrder componentWillReceiveProps ", nextProps);
        if (nextProps.paused === true) {
            //console.log("paused:", nextProps.paused);
            this.setState({
                paused: true
            });
        } else {
            //console.log("else paused:", nextProps.paused);
            this.setState({
                paused: false
            });
        }
    }

    /**
     * based on the paused state, will disable the input for market orders
     * @returns {*}
     */
    render() {
        //console.log("MarketOrder render");
        return (
            <div className='market-orders'>

                <div className='market-buy-container'>
                    Market Sell:
                    <input
                        disabled={this.state.paused}
                        onKeyUp={this.handleMarketKeyUp}
                        type="text"
                        name="marketAsk"
                        size="4"
                    />
                </div>
                <div className='market-sell-container'>
                    Market Buy:
                    <input
                        disabled={this.state.paused}
                        onKeyUp={this.handleMarketKeyUp}
                        type="text"
                        name="marketBid"
                        size="4"
                    />
                </div>
            </div>
        );
    }
}

MarketOrders.propTypes = {
    sessionid: PropTypes.string,
    uid: PropTypes.string
};

export default MarketOrders;



// WEBPACK FOOTER //
// ./src/components/Orderbook/MarketOrders.js